const topics = [
  {

    title: "Atoms", standardNumber: "5-PS1-1 ", slug: "atoms",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fatoms.mp4?alt=media&token=fa704dc0-3c39-4a4c-b9a4-c2f912212d28",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fatoms2025song.mp3?alt=media&token=717cc6c2-e7ba-48b2-a09a-607d6ce2735e",
        lyrics: ["(Chorus)",
    "Atoms, the smallest particles of matter.",
    "Atoms, the smallest particles of matter.",
    
    "They’re made of protons (positive),",
    "Electrons (negative),",
    "And neutrons (no charge, no charge).",
    "They’re made of protons (positive),",
    "Electrons (negative),",
    "And neutrons (no charge, no charge).",
    
    "(Verse)",
    "Protons and neutrons are in the center of an atom",
    "Called the nucleus.",
    "Electrons float around the nucleus",
    "In its orbitals.",
    "Protons and neutrons are in the center of an atom",
    "Called the nucleus.",
    "Electrons float around the nucleus",
    "In its orbitals.",
    
    "(Chorus)",
    "Atoms, the smallest particles of matter.",
    "Atoms, the smallest particles of matter.",
    
    "They’re made of protons (positive),",
    "Electrons (negative),",
    "And neutrons (no charge, no charge).",
    
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    {
    
    title: "3 States of Matter", standardNumber: "5-PS1-1 ", slug: "3statesofmatter",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F3statesofmatter2025video.mp4?alt=media&token=a521644b-b4eb-4a56-89e2-2beb95c71ad7",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F3statesofmatter2025song.mp3?alt=media&token=4ca634b8-d275-41d6-9e49-36d59970db1b",
        lyrics: ["(Chorus)",
    "Matter is everything around you.",
    "Matter is made of atoms and molecules.",
    "3 states: solids, liquids, gases.",
    "3 states: solids, liquids, gases.",
    
    "(Verse)",
    "Solids, yes, are hard.",
    "Liquids are more like water.",
    "Gases are like the atmosphere,",
    "That surrounds the earth, our air.",
    "Solids, yes, are hard.",
    "Liquids are more like water.",
    "Gases are like the atmosphere,",
    "That surrounds the earth, our air.",
    "Those are the 3 states of matter,",
    "Those are the 3 states of matter.",
    "Solids, liquids, gases.",
    "Solids, liquids, gases.",
    
    "(Chorus)",
    "Matter is everything around you.",
    "Matter is made of atoms and molecules.",
    "3 states: solids, liquids, gases.",
    "3 states: solids, liquids, gases.",
    
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    
    
    {
    
    title: "Dissolve", standardNumber: "5-PS1-1 ", slug: "dissolve",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "",
        lyrics: [
          
        ],
      },
    
    
    {
    
    title: "Hot Water Dissolves Faster", standardNumber: "5-PS1-1 ", slug: "hotwaterdissolvesfaster",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fhotwaterdissolvesfaster2025song.mp3?alt=media&token=d061262d-e2d3-41ff-b7cc-177c76389a3b",
        lyrics: ["(chorus)",
    "When you put sugar in hot water it dissolves faster,",
    "it dissolves faster, it dissolves faster.",
    "When you put sugar in hot water it dissolves faster,",
    "it dissolves faster, it dissolves faster,",
    "than it does in cold water,",
    "because hot water has more energy,",
    "hot water has more energy,",
    "hot water has more energy.",
    
    "(verse)",
    "When you heat the water, the molecules gain energy.",
    "When you heat the water, the molecules gain energy.",
    "When the molecules gain energy, they move faster.",
    "When the molecules gain energy, they move faster.",
    "The faster molecules come into contact with the sugar more often,",
    "causing the sugar to dissolve faster, causing the sugar to dissolve faster.",
    
    "(chorus)",
    "When you put sugar in hot water it dissolves faster,",
    "it dissolves faster, it dissolves faster.",
    "When you put sugar in hot water it dissolves faster,",
    "it dissolves faster, it dissolves faster,",
    "than it does in cold water,",
    "because hot water has more energy,",
    "hot water has more energy,",
    "hot water has more energy.",
    
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    {
    
    title: "Phase Changes", standardNumber: "5-PS1-2 ", slug: "phasechanges",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "",
        lyrics: [
          
        ],
      },
    {
    
    title: "Evaporation ", standardNumber: "5-PS1-2 ", slug: "evaporation",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "",
        lyrics: [
          
        ],
      },
    {
    
    title: "Freeze It Up", standardNumber: "5-PS1-2 ", slug: "freezeitup",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ffreezeitup2025song.mp3?alt=media&token=c3cd57e6-778b-400d-ae8c-bde7465b128c",
        lyrics: ["(chorus)",
    "Freeze it up, freeze it up with knowledge.",
    "Freeze it up, a liquid to solid!",
    "When it gets cold, it starts to freeze,",
    "Ice and frost, as cold as you please!",
    
    "(verse)",
    "Water turns to ice when the temperature is low.",
    "Put it in the freezer and watch the ice show.",
    "Juice turns to popsicles, solid and sweet,",
    "Then you pull out the popsicle and have a cool treat!",
    "When freezing happens, the heat goes away,",
    "Liquids turn solid in a frosty display.",
    "Snowflakes form when the air gets cold,",
    "Freezing is a wonder that never gets old!",
    
    "(chorus)",
    "Freeze it up, freeze it up with knowledge.",
    "Freeze it up, a liquid to solid!",
    "When it gets cold, it starts to freeze,",
    "Ice and frost, as cold as you please!",
    
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    {
    
    title: "Melting, Boiling, Freezing Points", standardNumber: "5-PS1-2 ", slug: "meltingboilingfreezingpoints",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmeltingboilingfreezing2025song.mp3?alt=media&token=3bb7cd69-462c-4be6-a8ec-a213b28bde31",
        lyrics: ["(verse)",
    "Melting point is the temperature where a substance melt.",
    "Melting point is the temperature where a substance melt.",
    "At the melting point, ice can turn from a solid into a liquid.",
    "At the melting point, ice melts at 0 degrees Celsius.",
    "Freezing point is also the point where water freezes.",
    "Freezing point is almost the same as the melting point by degrees.",
    "At the freezing point water can turn from a liquid into a solid.",
    "At the freezing point, water freezes at 0 degrees Celsius.",
    "Boiling point is the temperature where a substance evaporates.",
    "Boiling point is the temperature where a substance evaporates.",
    "At the boiling point water can turn from a liquid into a gas.",
    "At the boiling point, water boils at 100 degrees Celsius.",
    "Different substances have different melting point temperatures.",
    "Different substances have different boiling point temperatures.",
    "Different substances have different freezing point temperatures.",
    
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    {
    
    title: "Same Weight", standardNumber: "5-PS1-2 ", slug: "sameweight",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "",
        lyrics: [
          
        ],
      },
    {
    
    title: "Heat and Cooling", standardNumber: "5-PS1-2 ", slug: "heatandcooling",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fheatingandcooling2025song.mp3?alt=media&token=f9370550-3077-42ee-a0a0-a8a01a268baa",
        lyrics: ["(chorus)",
    "Heat it up, cool it down,",
    "Watch the changes all around!",
    "Liquids to gas, or solid to ice,",
    "Heating and cooling, science is nice!",
    
    "(verse)",
    "Add some heat, water turns to steam,",
    "It floats in the air like a misty dream.",
    "Cool it down, and watch it fall,",
    "Rain turns to puddles, that’s not all!",
    "Heat melts butter, chocolate too,",
    "Cooling makes them hard, it’s what they do!",
    "Ice turns to water, then back again,",
    "Heating and cooling are science friends!",
    
    "(chorus)",
    "Heat it up, cool it down,",
    "Watch the changes all around!",
    "Liquids to gas, or solid to ice,",
    "Heating and cooling, science is nice!",
    
    "(verse)",
    "Evaporation makes water disappear,",
    "Heating it up sends it out of here!",
    "Cooling it down makes it come back,",
    "Forming clouds or frost, on nature’s track.",
    "So heat it up, and cool it too,",
    "Changes in matter are fun to do.",
    "Evaporation, melting, freezing, it’s true,",
    "Heating and cooling teach me and you!",
    
    "(chorus)",
    "Heat it up, cool it down,",
    "Watch the changes all around!",
    "Liquids to gas, or solid to ice,",
    "Heating and cooling, science is nice!",
    
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    {
    
    title: "Heat It Up", standardNumber: "5-PS1-2 ", slug: "heatitup",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fheatitup2025song.mp3?alt=media&token=fe4766c1-a50e-4bf3-9af3-4e816a93eadd",
        lyrics: ["(chorus)",
    "Heat it up, watch it change,",
    "A solid to liquid, isn’t that strange?",
    "Melting happens when it gets hot,",
    "Heat it up, that’s what we’ve got!",
    
    "(verse)",
    "Ice turns to water, it’s easy to see,",
    "Add some heat, it melts naturally.",
    "Chocolate melts into a gooey flow,",
    "Heat it up, and watch it go!",
    "Wax from a candle melts in the flame,",
    "It’s still the same wax, just a different name.",
    "Sometimes the change won’t go back,",
    "Like baking cookies for a tasty snack!",
    
    "(chorus)",
    "Heat it up, watch it change,",
    "A solid to liquid, isn’t that strange?",
    "Melting happens when it gets hot,",
    "Heat it up, that’s what we’ve got!",
    
    "(verse)",
    "When heat is added, solids can fade,",
    "Into liquids, the change is made.",
    "Sometimes it’s reversible, sometimes it’s not,",
    "But heat is the key to the whole big plot!",
    "So heat it up, and watch it flow,",
    "Melting solids, now you know.",
    "Science is cool, it’s fun to see,",
    "How heat brings changes to you and me!",
    
    "(chorus)",
    "Heat it up, watch it change,",
    "A solid to liquid, isn’t that strange?",
    "Melting happens when it gets hot,",
    "Heat it up, that’s what we’ve got!",
    
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    {
    
    title: "Heat Moves All Around", standardNumber: "5-PS1-2 ", slug: "heatmovesallaround",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "",
        lyrics: [
          
        ],
      },
    {
    
    title: "Properties of Matter", standardNumber: "5-PS1-3 ", slug: "propertiesofmatter",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "",
        lyrics: [
          
        ],
      },
    {
    
    title: "Rocks & Minerals", standardNumber: "5-PS1-3 ", slug: "rocksandminerals",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Frocksandminerals2025video.mp4?alt=media&token=ed79117e-fc45-400c-82de-b56332f93e1e",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Frocksandminerals2025song.mp3?alt=media&token=908ef6b0-b264-49ea-b2d4-742bc97ebed9",
        lyrics: ["(Chorus)",
    "We use rocks & minerals every day.",
    "We use rocks & minerals every day.",
    "We use rocks & minerals every day.",
    "We use rocks & minerals every day.",
    
    "(Verse 1)",
    "Buildings and bridges are all made of rock.",
    "Even the roads we drive on with our car.",
    "Metals come from minerals.",
    "Cars and planes use different minerals.",
    "The salt on my food is a mineral.",
    "The gold that I buy is a mineral.",
    "Every day, we’re all around rocks and minerals.",
    "Now, can you name some uses of rocks and minerals?",
    
    "(Chorus)",
    "We use rocks & minerals every day.",
    "We use rocks & minerals every day.",
    "We use rocks & minerals every day.",
    "We use rocks & minerals every day.",
    
    "(Verse 2)",
    "Now all rocks are made up of two or more minerals,",
    "But minerals aren't made up of rock.",
    "Now all rocks are made up of two or more minerals,",
    "But minerals aren't made up of rock.",
    "There's about 3,000 minerals known on Earth,",
    "And different combinations of them make rocks.",
    
    "(Chorus)",
    "We use rocks & minerals every day.",
    "We use rocks & minerals every day.",
    "We use rocks & minerals every day.",
    "We use rocks & minerals every day.",
    
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    {
    
    title: "Conductors", standardNumber: "5-PS1-3 ", slug: "conductors",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fconductors2025video.mp4?alt=media&token=575ccfe3-62fb-426b-ad44-5882b54eb356",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fconductors2025song.mp3?alt=media&token=1c1e3505-da36-40da-ae69-d7daa4f17d19",
        lyrics: ["(chorus)",
    "Conductors and insulators.",
    "Conductors and insulators.",
    "Conductors and insulators.",
    "Conductors and insulators.",
    
    "(verse 1)",
    "What makes materials conduct electricity?",
    "When electrons jump.",
    "What makes materials conduct electricity?",
    "When electrons jump from one atom,",
    "into an empty space of another atom.",
    "The moving of electrons causes electrical currents.",
    "Insulator, a material that electrical charges cannot move through,",
    "cannot move through.",
    "Conductor, a material that electrical charges easily flow through,",
    "flow through.",
    "Copper, conductor.",
    "Gold, conductor.",
    "Rubber, insulator.",
    "Styrofoam, insulator.",
    
    "(chorus)",
    "Conductors and insulators.",
    "Conductors and insulators.",
    "Conductors and insulators.",
    "Conductors and insulators.",
    
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    {
    
    title: "Mineral Properties", standardNumber: "5-PS1-3 ", slug: "mineralproperties",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "",
        lyrics: [
          
        ],
      },
    {
    
    title: "Compound ", standardNumber: "5-PS1-4", slug: "compound",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "",
        lyrics: [
          
        ],
      },
    {
    
    title: "Mixtures", standardNumber: "5-PS1-4", slug: "mixtures",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "",
        lyrics: [
          
        ],
      },
    {
    
    title: "Gravity ", standardNumber: "5-PS2-1", slug: "gravity",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fgravityvideo.mp4?alt=media&token=63493362-6c8b-4590-ac8f-49b9b794b17a",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fgravity2025song.mp3?alt=media&token=48857943-5ba4-441d-b04b-0802504ceae4",
        lyrics: ["(chorus)",
    "Earth is one of eight planets that go around the sun.",
    "Asteroids, comets, and dust particles all go around the sun.",
    "Earth is one of eight planets that go around the sun.",
    "Asteroids, comets, and dust particles all go around the sun,",
    "because gravity, gravity, gravity, gravity, gravity,",
    "because",
    
    "(verse 1)",
    "Everything is made up of matter.",
    "The amount of matter is called mass.",
    "Now some objects have great mass than others.",
    "Some objects have little.",
    "In space objects with greater mass",
    "pull other objects together, together.",
    
    "(chorus)",
    "Earth is one of eight planets that go around the sun.",
    "Asteroids, comets, and dust particles all go around the sun.",
    "Earth is one of eight planets that go around the sun.",
    "Asteroids, comets, and dust particles all go around the sun,",
    "because gravity, gravity, gravity, gravity, gravity,",
    "because",
    
    "(verse 2)",
    "Without gravity everything on earth",
    "will go floating in the air.",
    "Gravity pulling us towards earth’s center",
    "keeps us here, keeps us here.",
    "So, when you jump up, you go back down.",
    "Throw a ball up and it comes right down.",
    "That’s gravity, gravity, gravity, gravity, gravity,",
    "because",
    
    "(chorus)",
    "Earth is one of eight planets that go around the sun.",
    "Asteroids, comets, and dust particles all go around the sun.",
    "Earth is one of eight planets that go around the sun.",
    "Asteroids, comets, and dust particles all go around the sun,",
    "because gravity, gravity, gravity, gravity, gravity,",
    "because…",
    
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    {
    
    title: "Eco Energy Flow", standardNumber: "5-PS3-1", slug: "ecoenergyflow",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "",
        lyrics: [
          
        ],
      },
    {
    
    title: "Things Plants Need", standardNumber: "5-LS1-1", slug: "thingsplantsneed",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fthingsplantsneed2025video.mp4?alt=media&token=13010d5d-3513-42e1-88ef-e35908d024cd",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fthingsplantsneed2025song.mp3?alt=media&token=58839d9c-7e4f-40c7-bd9b-66865d87379b",
        lyrics: ["(Chorus)",
    "What do plants need? Let’s find out!",
    "Water, air, and light, no doubt.",
    "Shelter and space to grow up tall,",
    "Plants need these to give us all!",
    
    "(Verse 1)",
    "Plants need water to drink each day,",
    "It helps their roots in every way.",
    "They reach for light from the sun so bright,",
    "It helps them grow both day and night!",
    
    "(Chorus)",
    "What do plants need? Let’s find out!",
    "Water, air, and light, no doubt.",
    "Shelter and space to grow up tall,",
    "Plants need these to give us all!",
    
    "(Verse 2)",
    "Air is around, it helps them breathe,",
    "It’s one more thing that plants do need.",
    "With space to stretch and shelter near,",
    "They grow so strong, year after year!",
    
    "(Bridge)",
    "Roots in the ground, leaves to the sky,",
    "Plants grow tall and reach up high.",
    "They need these things, it’s easy to see,",
    "Water, air, light, and space are key!",
    
    "(Chorus)",
    "What do plants need? Let’s find out!",
    "Water, air, and light, no doubt.",
    "Shelter and space to grow up tall,",
    "Plants need these to give us all!",
    
    "(Outro)",
    "So care for the plants, give them their space,",
    "Water and sunlight in the right place.",
    "Watch them grow, it’s fun to see,",
    "Plants are special for you and me!",
    
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    {
    
    title: "What Do Plants Need", standardNumber: "5-LS1-1", slug: "whatdoplantsneed",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fwhatdoplantsneed2025video.mp4?alt=media&token=2172b66c-8868-45bf-8a14-dd8f6be2f4ec",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fwhatdoplantsneed2025song.mp3?alt=media&token=95132d97-2377-471a-9d92-9562b9dec2e7",
        lyrics: ["(Chorus)",
    "Plants and animals change as they grow.",
    "There are a few things we know",
    "That they need for survival.",
    
    "(Verse 1)",
    "Animals need food and water.",
    "Animals need food and water.",
    "Animals need air and shelter.",
    "Animals need air and shelter.",
    "Some animals get their oxygen from the air.",
    "That makes them terrestrial.",
    "Some animals get their oxygen from the water.",
    "That makes them aquatic.",
    
    "(Chorus)",
    "Plants and animals change as they grow.",
    "There are a few things we know",
    "That they need for survival.",
    
    "(Verse 2)",
    "Plants need air, light, water, and nutrients from the soil.",
    "Plants need air, light, water, and nutrients from the soil.",
    "Plants provide food for people.",
    "Plants provide food for animals.",
    "Plants can be aquatic.",
    "Plants can be terrestrial.",
    
    "(Chorus)",
    "Plants and animals change as they grow.",
    "There are a few things we know",
    "That they need for survival.",
    
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    {
    
    title: "Photosynthesis", standardNumber: "5-LS1-1", slug: "photosynthesis",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fphotosynthesis2025video.mp4?alt=media&token=f1dd2985-8798-48a4-bac0-e8e9ad8cd07d",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fphotosynthesis2025song.mp3?alt=media&token=4c2bbcca-ccbe-4515-be6f-8604eb8bb65e",
        lyrics: ["(Chorus)",
    "Photosynthesis is the process of how plants make food.",
    "Photosynthesis is the process of how plants make food.",
    "Photosynthesis is the process of how plants make food.",
    "Photosynthesis is the process of how plants make food.",
    
    "(Verse)",
    "Energy coming from the sunlight, is what we need to get this started.",
    "Water gathered by the roots right, is what we need to get this started.",
    "Carbon dioxide from the air, is what we need to get this started.",
    "Chlorophyll in the cells of green plants, is what we need to get this started.",
    "The chlorophyll takes in the light from the sun.",
    "The sun's energy splits the water into hydrogen and oxygen.",
    "The hydrogen mixes with the carbon dioxide to make the food, yeah,",
    "and the food is carried throughout the plant while the oxygen goes into the air.",
    
    "(Chorus)",
    "Photosynthesis is the process of how plants make food.",
    "Photosynthesis is the process of how plants make food.",
    "Photosynthesis is the process of how plants make food.",
    "Photosynthesis is the process of how plants make food.",
    
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    {
    
    title: "Plant Parts", standardNumber: "5-LS1-1", slug: "plantparts",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fplantparts2025song.mp3?alt=media&token=64dfa273-9473-4f12-ae5f-d08c8e11a18c",
        lyrics: ["(chorus)",
    "Plant Parts",
    "Roots, stems, leaves, flowers, fruits, seeds",
    "Plant Parts",
    "Roots, stems, leaves, flowers, fruits, seeds",
    
    "(verse)",
    "Plant Parts",
    "The Roots take in the water and nutrients OK",
    "The Roots hold the Plant down, so it does not blow away",
    "Plant Parts",
    "The Stem takes the water and nutrients up to the Leaves",
    "The Leaves make food “Photosynthesis” yes their green",
    "The Flowers go through Fertilization they make the seeds",
    "The Fruit is the part that swells up and it holds the seeds",
    "The Seed is a tiny Plant called the Embryo",
    "and it's waiting to Germinate so that it can grow",
    
    "(chorus)",
    "Plant Parts",
    "Roots, stems, leaves, flowers, fruits, seeds",
    "Plant Parts",
    "Roots, stems, leaves, flowers, fruits, seeds",
    
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    {
    
    title: "Food Chain", standardNumber: "5-LS2-1", slug: "foodchain",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "",
        lyrics: [
          
        ],
      },
    {
    
    title: "Food Web", standardNumber: "5-LS2-1", slug: "foodweb",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ffoodweb2025video.mp4?alt=media&token=1c7eae0b-5548-486a-8a71-7af001a21cb5",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ffoodweb2025song.mp3?alt=media&token=d9108a4b-545b-4ce0-ac4f-f96ce831ccd2",
        lyrics: ["(Chorus)",
    "In a food web, we see how plants and animals connect.",
    "In a food web, we see how plants and animals connect,",
    "Through many paths, through many paths.",
    "A food chain shows just one way to go,",
    "But a food web shows how life can grow.",
    
    "(Verse 1)",
    "Trees make acorns, food for bugs and mice.",
    "When the mice are here, snakes and owls think it’s nice.",
    "Bugs are food for birds, and skunks eat them too.",
    "Every animal matters, they all have jobs to do.",
    "If one animal goes, the others feel the loss.",
    "Like a broken web, it comes at a big cost.",
    
    "(Chorus)",
    "In a food web, we see how plants and animals connect.",
    "In a food web, we see how plants and animals connect,",
    "Through many paths, through many paths.",
    "A food chain shows just one way to go,",
    "But a food web shows how life can grow.",
    
    "(Verse 2)",
    "Plants give food to animals, animals help them grow.",
    "If one part disappears, it’s hard for others, you know.",
    "Foxes eat the rabbits, rabbits eat the grass.",
    "Everything works together so nature can last.",
    "The food web is a circle, a balance we must keep.",
    "Protecting every animal and the places where they sleep.",
    
    "(Chorus)",
    "In a food web, we see how plants and animals connect.",
    "In a food web, we see how plants and animals connect,",
    "Through many paths, through many paths.",
    "A food chain shows just one way to go,",
    "But a food web shows how life can grow.",
    
    "(Outro)",
    "So let’s take care of nature, the plants, the animals too.",
    "The food web keeps them living, and it helps us all too!",
    
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    {
    
    title: "Producers, Consumers, and Decomposers", standardNumber: "5-LS2-1", slug: "producersconsumersdecomposers",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "",
        lyrics: [
          
        ],
      },
    {
    
    title: "The Sun", standardNumber: "5-ESS1-1 ", slug: "thesun",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fthesun2025song.mp3?alt=media&token=2e9b9293-2f9f-46d9-b27d-76f50b56b437",
        lyrics: ["(chorus)",
    "I shine, you shine, we shine just like the sun.",
    "I shine, you shine, we shine just like the sun.",
    "I shine, you shine, we shine just like the sun.",
    "I shine, you shine, we shine just like the sun.",
    
    "(verse1)",
    "I shine bright like the sun and it’s so big.",
    "If it were hollow, you could fit a million earths in it.",
    "it’s just a middle size star and it looks small,",
    "because its ninety-three million miles, away far.",
    "it’s made of hydrogen, helium, metals and more.",
    "Hydrogen changes to helium in its core.",
    "The sun is 98% of the solar system’s mass.",
    "With out the sun’s energy on earth, we wouldn’t last.",
    
    "(chorus)",
    "I shine, you shine, we shine just like the sun.",
    "I shine, you shine, we shine just like the sun.",
    
    "(verse2)",
    "The sun’s outer layer is the photosphere.",
    "It has a temperature of 11,000 degrees.",
    "On the photosphere, you’ve got sunspots.",
    "Sunspots are the cooler spots.",
    "The next layer is chromosphere.",
    "Visible only during an eclipse.",
    "The outer most layer of the sun’s atmosphere",
    "is the corona,",
    "and during a total solar eclipse",
    "you’ll see the corona.",
    "Corona is bright in x-rays,",
    "very large, and extremely hot.",
    "Without the sun’s energy on earth, we wouldn’t last.",
    
    "(chorus)",
    "I shine, you shine, we shine just like the sun.",
    "I shine, you shine, we shine just like the sun.",
    "I shine, you shine, we shine just like the sun.",
    "I shine, you shine, we shine just like the sun.",
    
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    {
    
    title: "Earth’s Rotation", standardNumber: "5-ESS1-2", slug: "earthsrotation",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fearthsrotation.mp4?alt=media&token=a31d8de2-9598-4afe-bfcb-c3b51a18246c",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fearthsrotation.mp3?alt=media&token=9312642c-9568-452a-8cc8-634c7e5d125f",
        lyrics: ["(chorus)",
    "Earth rotates around and around,",
    "around and around again.",
    "Earth rotates around and around,",
    "around and around again.",
    
    "(verse)",
    "The Earth spins on its axis,",
    "it's turning, it's turning.",
    "Makes the sky look like it's moving,",
    "it's turning, it's turning.",
    "It makes the sun, moon, and stars ",
    "look like they’re rising in the east.",
    "Then, cross the sky to set in the west, eventually.",
    "That's because the Earth is turning, spinning on its axis.",
    "It makes a full turn every 24 hours.",
    "That is the reason for our day and night, night and day.",
    "That is the reason for our day and night, night and day.",
    
    "(chorus)",
    "Earth rotates around and around,",
    "around and around again.",
    "Earth rotates around and around,",
    "around and around again.",
    
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    {
    
    title: "The Sun Bright Light", standardNumber: "5-ESS1-1 ", slug: "thesunbrightlight",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "",
        lyrics: [
          
        ],
      },
    {
    
    title: "Earth’s Revolution", standardNumber: "5-ESS1-2", slug: "earthsrevolution",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fearthsrevolution.mp4?alt=media&token=49a38c8b-48fc-4c3c-92ca-463a577121dc",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fearthsrevolution2025song.mp3?alt=media&token=29c46e1a-08f3-4b3c-ac70-d64d55ec2386",
        lyrics: ["(verse)",
    "A revolution is one year,",
    "365 days is how long it takes",
    "for the Earth to go around the Sun.",
    "It takes one year, that's a revolution.",
    
    "(chorus)",
    "Earth's revolution, orbit of the Earth.",
    "Earth's revolution, orbit of the Earth.",
    "Earth's revolution, orbit of the Earth.",
    "Earth's revolution.",
    
    "(verse)",
    "A revolution is one year,",
    "365 days is how long it takes",
    "for the Earth to go around the Sun.",
    "It takes one year, that's a revolution.",
    
    "(chorus)",
    "Earth's revolution, orbit of the Earth.",
    "Earth's revolution, orbit of the Earth.",
    "Earth's revolution, orbit of the Earth.",
    "Earth's revolution, orbit of the Earth.",
    "Earth's revolution, orbit of the Earth.",
    "Earth's revolution, orbit of the Earth.",
    "Earth's revolution, orbit of the Earth.",
    "Earth's revolution.",
    
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    {
    
    title: "Night & Day", standardNumber: "5-ESS1-2", slug: "nightandday",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fnightandday2025video.mp4?alt=media&token=0df32858-e1bd-4e92-9c18-dc595d6b52a9",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fdayandnight2025song.mp3?alt=media&token=2d2b7b35-895a-4226-8d35-bb5a2056564d",
        lyrics: ["(Intro)",
    "Day and night, day and night, day and night, day and night.",
    "Night and day, night and day, night and day, night and day.",
    
    "(Chorus)",
    "In the daytime, you see the light and it’s dark at night,",
    "Yeah, it’s dark at night,",
    "Yeah, yeah, it’s dark at night.",
    "In the daytime, you see the light and it’s dark at night,",
    "Yeah, it’s dark at night,",
    "Yeah, yeah, it’s dark at night.",
    
    "(Verse)",
    "Because the Earth spins around,",
    "And makes a full turn in 24 hours,",
    "The sun only lights up half of the Earth at a time.",
    "The side with the light is daytime.",
    "The other side is dark—that’s nighttime.",
    "As the Earth spins, daytime shifts to the other side.",
    "As the Earth spins, nighttime shifts to the other side.",
    
    "(Chorus)",
    "In the daytime, you see the light and it’s dark at night,",
    "Yeah, it’s dark at night,",
    "Yeah, yeah, it’s dark at night.",
    "In the daytime, you see the light and it’s dark at night,",
    "Yeah, it’s dark at night,",
    "Yeah, yeah, it’s dark at night.",
    
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    {
    
    title: "Moon Phases", standardNumber: "5-ESS1-2", slug: "moonphases",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmoonphasesrap2025video.mp4?alt=media&token=b2c7a588-ca4a-4103-b790-c9e5b040a867",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmoonphasesrap2025song.mp3?alt=media&token=88173bf0-b997-4602-b9b3-671337ff8cc1",
        lyrics: ["(Chorus)",
    "Phases of the moon.",
    "New moon, waxing crescent, first quarter, waxing gibbous.",
    "Phases of the moon.",
    "Full moon, waning gibbous, last quarter, waning crescent.",
    "Phases of the moon.",
    "New moon, waxing crescent, first quarter, waxing gibbous.",
    "Phases of the moon.",
    "Full moon, waning gibbous, last quarter, waning crescent.",
    "(Verse 1)",
    "When the moon is in the same direction of the sun,",
    "It’s called the new moon, new moon.",
    "When you don’t see no light, coming from the moon,",
    "It is a dark moon, called the new moon.",
    "A crescent moon is in the next stage,",
    "When the moon is lit a quarter of the way.",
    "Less than half but more than zero.",
    "This is called a crescent moon, true.",
    "Now a quarter moon’s a half-moon.",
    "You see, a half-moon’s a quarter moon,",
    "Quarter moon’s a half-moon.",
    "They call a half-moon a quarter moon, word,",
    "Because it made a quarter of its turn around the earth.",
    "You see half of the moon lit up,",
    "And I know what you’re thinking but,",
    "It’s a half-moon, called a quarter moon.",
    "Half-moon’s a quarter moon,",
    "Quarter moon’s a half-moon.",
    "(Chorus)",
    "Phases of the moon.",
    "New moon, waxing crescent, first quarter, waxing gibbous.",
    "Phases of the moon.",
    "Full moon, waning gibbous, last quarter, waning crescent.",
    "Phases of the moon.",
    "New moon, waxing crescent, first quarter, waxing gibbous.",
    "Phases of the moon.",
    "Full moon, waning gibbous, last quarter, waning crescent.",
    "(Verse 2)",
    "Now, the gibbous moon is a little more full,",
    "But not all the way full.",
    "The lit-up part is between a full moon,",
    "And a half-moon called the gibbous moon.",
    "Now the full moon shines so bright.",
    "You see the full moon light up the night.",
    "Halfway through a circle, circle,",
    "You’ll see the full moon light up the night.",
    "(Chorus)",
    "Phases of the moon.",
    "New moon, waxing crescent, first quarter, waxing gibbous.",
    "Phases of the moon.",
    "Full moon, waning gibbous, last quarter, waning crescent.",
    "Phases of the moon.",
    "New moon, waxing crescent, first quarter, waxing gibbous.",
    "Phases of the moon.",
    "Full moon, waning gibbous, last quarter, waning crescent.",
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    {
    
    title: "Seasons", standardNumber: "5-ESS1-2", slug: "seasons",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fseasons2025video.mp4?alt=media&token=dd682414-ff8a-4acb-8877-5a488cd7a912",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fseasons2025song.mp3?alt=media&token=04a34ce0-7b3c-4e70-8564-cc5ac75c2bfc",
        lyrics: ["(chorus)",
    "There is something we have to get clear now,",
    "there are four seasons in every year now.",
    "Do you know the reasons for the seasons? Check this,",
    "seasons come because of the tilt of the Earth's axis.",
    
    "(verse)",
    "We spring ahead in the Spring, then comes the Summer.",
    "Watch the leaves change color, we fall back in Autumn.",
    "Then comes the Winter, which is the coldest season.",
    "The Earth spins on an axis that is tilted, is the reason why this happens.",
    
    "(chorus)",
    "There is something we have to get clear now,",
    "there are four seasons in every year now.",
    "Do you know the reasons for the seasons? Check this,",
    "seasons come because of the tilt of the Earth's axis.",
    
    "(bridge)",
    "Summer, Winter, Spring, Fall.",
    "Summer, Winter, Spring, Fall.",
    "Summer, Winter, Spring, Fall.",
    "Summer, Winter, Spring, Fall.",
    
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    {
    
    title: "Spheres", standardNumber: "5-ESS2-1", slug: "spheres",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "",
        lyrics: [
          
        ],
      },
    {
    
    title: "Atmosphere", standardNumber: "5-ESS2-1", slug: "atmosphere",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "",
        lyrics: [
          
        ],
      },
    {
    
    title: "Reduce, Reuse, & Recycle", standardNumber: "5-ESS3-1", slug: "reducereuserecycle",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Freducereuseandrecycle2025video.mp4?alt=media&token=e70c95fb-a41d-41b7-b8c3-ef00cb03b098",
        music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Freducereuserecycle2025song.mp3?alt=media&token=55526bc5-628f-4a12-94b4-b0b6ea6dda21",
        lyrics: ["(Chorus)",
    "Reducing, reusing, and recycling protects your environment.",
    "Reducing, reusing, and recycling protects your environment.",
    "Reducing, reusing, and recycling can eliminate waste.",
    
    "(Verse)",
    "You can reduce by refusing store bags.",
    "Carry small items out in your hands.",
    "You can reuse cups that’s washable,",
    "Instead of foam cups that’s disposable.",
    "You can recycle papers and plastics, papers, and plastics,",
    "Yup, yup, yup, papers and plastics.",
    
    "(Chorus)",
    "Reducing, reusing, and recycling protects your environment.",
    "Reducing, reusing, and recycling protects your environment.",
    "Reducing, reusing, and recycling can eliminate waste.",
    
    "© Smart Board Learning, LLC. All rights reserved.",
          
        ],
      },
    {
    
    title: "Conserve Water", standardNumber: "5-ESS3-1", slug: "conservewater",
    gameType: "multipleChoice", titleImage: "", // Motion image URL
        description: "",
        video: "",
        music: "",
        lyrics: [
          
        ],
      },
    

];
export default topics;